export const getSheetStatus = (sheet) => {
  let statusText = '';
  let status = '';
  if (sheet.canceledAt) {
    statusText = 'Canceled';
    status = 'canceled';
  } else if (sheet.verificationStatus === 'verified') {
    statusText = 'Verified';
    status = 'verified';
  } else if (sheet.verificationStatus === 'pending') {
    statusText = 'Pending verification';
    status = 'pending';
  } else if (sheet.submittedAt) {
    statusText = 'Submitted';
    status = 'submitted';
  } else if (sheet.published) {
    statusText = 'Published';
    status = 'published';
  } else {
    statusText = 'Draft';
    status = 'draft';
  }

  return { statusText, status };
}